export default "__VITE_PUBLIC_ASSET__0edf0d6f__"